import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["src"]

import BlockTitle from './BlockTitle.vue'
import { ProfileMeta } from '@/store/profile.interface'
import { ElAutocomplete, ElFormItem, ElMessage, ElTooltip, ElUpload, FormInstance, FormRules } from 'element-plus'
import { reactive, ref, onMounted, computed } from 'vue'
import { Plus, Document, CircleClose } from '@element-plus/icons-vue'
import { NewProfileStore } from '@/store/newProfileStore'
import api from '@/api/api'
import resource from '@/api/resource'
import { v4 as uuid } from 'uuid'
import axios from 'axios'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileMetaForm',
  setup(__props, { expose: __expose }) {

const store = new NewProfileStore()
const metaFormRef = ref<FormInstance>()

const meta = ref(store.GetProfileMeta())
const imageUrl = ref('')
const imageUploading = ref(false)
const docUploading = ref(false)
const isEdit = ref(false)
const metaRules = ref<FormRules<ProfileMeta>>({
  model: { type: 'string', required: true },
  vendor: { type: 'string', required: true },
  description: { type: 'string', required: true }
})

const vendors = [{ value: 'RAKwireless' }, { value: 'Senso8' }]

const vendorSearch = (queryString: string, cb: any) => {
  const results = queryString
    ? vendors.filter((item) => {
      return item.value.toLowerCase().startsWith(queryString.toLowerCase())
    })
    : vendors
  // call callback function to return suggestions
  cb(results)
}

const doUpload = async (url:string, file:any) => {
  return new Promise<void>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = async () => {
      await axios.put(url, reader.result, {
        headers: {
          'Content-Type': file.type
        }
      }).then(() => {
        setTimeout(() => {
          resolve()
        }, 200)
      }).catch(err => {
        reject(err)
      })
    }

    reader.readAsArrayBuffer(file)
  })
}

const OnUploadDocument = async (options: any) => {
  const { file, onSuccess, onError } = options
  console.log(file)
  const formData = new FormData()
  formData.append('file', file)
  docUploading.value = true
  try {
    const response = await api.post('/resource/doc', {
      file: file.name,
      contentType: file.type,
      contentLength: file.size
    })

    const url = response.data.data
    await doUpload(url, file)
    meta.value.docs!.push(url.split('?')[0])
  } catch (error:any) {
    onError(error)
    ElMessage.error('Unable to upload profile: ' + error.response?.data.errorMessage)
  } finally {
    docUploading.value = false
  }
}

const OnUploadImage = async (options: any) => {
  const { file, onSuccess, onError } = options
  console.log('file is', file)

  try {
    imageUploading.value = true
    const response = await api.post('/resource/image', {
      file: file.name,
      contentType: file.type,
      contentLength: file.size
    })

    const url:string = response.data.data
    await doUpload(url, file)

    imageUrl.value = url.split('?')[0]
    meta.value.image = imageUrl.value
    onSuccess()
  } catch (error:any) {
    onError(error)
    ElMessage.error('Unable to upload profile: ' + error.message)
  } finally {
    imageUploading.value = false
  }
}
const Submit = async() => {
  return new Promise<void>((resolve, reject) => {
    metaFormRef.value!.validate((isvalid) => {
      if (isvalid) {
        store.SubmitMeta(meta.value).then(() => {
          return resolve()
        }).catch(err => {
          return reject(err)
        })
      } else {
        reject(new Error('Some fields are invalid'))
      }
    })
  })
}

const Load = () => {
  meta.value = store.GetProfileMeta()
  if (meta.value.model !== undefined) {
    isEdit.value = true
  }
  if (meta.value.image) { imageUrl.value = meta.value.image }
}

__expose({ Submit, Load })
onMounted(() => {
  Load()
})

return (_ctx: any,_cache: any) => {
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ElIcon = _resolveComponent("ElIcon")!
  const _component_ElText = _resolveComponent("ElText")!
  const _component_ElRow = _resolveComponent("ElRow")!
  const _component_ElForm = _resolveComponent("ElForm")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BlockTitle, { title: "Generic Settings" }),
    _createVNode(_component_ElForm, {
      model: meta.value,
      ref_key: "metaFormRef",
      ref: metaFormRef,
      "label-position": "left",
      "label-width": "auto",
      rules: metaRules.value,
      style: {"width":"600px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElFormItem), {
          prop: "model",
          label: "Device Model"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ElInput, {
              modelValue: meta.value.model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((meta.value.model) = $event)),
              readonly: isEdit.value
            }, null, 8, ["modelValue", "readonly"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), {
          prop: "vendor",
          label: "Vendor"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElAutocomplete), {
              modelValue: meta.value.vendor,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((meta.value.vendor) = $event)),
              clearable: "",
              placeholder: "Pleae input the device vendor",
              "fetch-suggestions": vendorSearch,
              readonly: isEdit.value
            }, null, 8, ["modelValue", "readonly"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), {
          prop: "description",
          label: "Feature Description"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ElInput, {
              modelValue: meta.value.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((meta.value.description) = $event)),
              type: "textarea",
              rows: "6"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "Device Picture" }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_unref(ElUpload), {
              class: "avatar-uploader",
              "auto-upload": true,
              "show-file-list": false,
              "http-request": OnUploadImage
            }, {
              default: _withCtx(() => [
                (imageUrl.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: imageUrl.value,
                      class: "avatar"
                    }, null, 8, _hoisted_1))
                  : (_openBlock(), _createBlock(_component_el_icon, {
                      key: 1,
                      class: "avatar-uploader-icon"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Plus))
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })), [
              [_directive_loading, imageUploading.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "Documents" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meta.value.docs, (name, idx) => {
              return (_openBlock(), _createBlock(_component_ElRow, {
                key: idx,
                style: {"width":"100%","align-items":"center"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElIcon, {
                    size: 24,
                    style: {"margin-right":"12px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Document))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ElText, { style: {"margin-right":"12px"} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(name.substring(name.lastIndexOf('/') + 1)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ElIcon, {
                    size: 18,
                    style: {"line-height":"24px","margin-right":"12px","color":"red","cursor":"pointer"},
                    onClick: ($event: any) => (meta.value.docs?.splice(idx, 1))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CircleClose))
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_ElRow, { style: {"width":"100%"} }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_unref(ElUpload), {
                  class: "file-uploader",
                  "auto-upload": true,
                  "show-file-list": false,
                  "http-request": OnUploadDocument
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "file-uploader-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Plus))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_loading, docUploading.value]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ], 64))
}
}

})